<template>
  <el-table-column :label="label" :prop="prop" class-name="paid-passengers" :sortable="sortable" >
    <template slot-scope="scope">
      {{scope.row.paid_passengers.toLocaleString()}}
    </template>
  </el-table-column>
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '有償旅客数'
    },
    prop: {
      type: String,
      default: 'paid_passengers'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.paid-passengers {
      width: 10em;
    }
  }
  td.paid-passengers {
    text-align: right;
  }
}
</style>
